import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async getAll() {
        const res = await http.get(buildUrlFromLocation("/components/categories"));

        return res.categories.map(({ id, subCategories, terms, name, color }) => {
            return {
                id,
                subCategories,
                terms,
                name,
                color
            };
        });
    }
};



// WEBPACK FOOTER //
// ./src/services/categories.js